import { format } from "date-fns";

type Unit = "index" | "percent";

function formatValue(v: unknown, unit: Unit) {
  const n = typeof v === "number" ? v : Number(v);
  if (!Number.isFinite(n)) return "—";
  if (unit === "percent") return `${n.toFixed(2)}%`;
  return n.toFixed(2);
}

function formatLabel(isoDate: string) {
  const d = new Date(isoDate);
  if (Number.isNaN(d.getTime())) return isoDate;
  return format(d, "MMM yy");
}

export function MacroChartTooltip({
  active,
  payload,
  label,
  unitLeft,
  unitRight,
}: {
  active?: boolean;
  payload?: Array<{ name?: string; value?: unknown; color?: string }>;
  label?: unknown;
  unitLeft: Unit;
  unitRight: "percent";
}) {
  if (!active || !payload?.length) return null;

  const dateLabel = typeof label === "string" ? label : String(label ?? "");
  const formattedDate = dateLabel ? formatLabel(dateLabel) : "";

  const nameMap: Record<string, string> = {
    realValue: "Dado Real (FRED)",
    marketExpectation: "Expectativa de Mercado (Polymarket)",
  };

  return (
    <div className="bg-popover/95 backdrop-blur border border-border rounded-lg px-3 py-2 shadow-lg">
      {formattedDate && (
        <p className="text-xs text-muted-foreground mb-1">{formattedDate}</p>
      )}

      {payload
        .filter((p) => p?.name)
        .map((entry, idx) => {
          const key = String(entry.name);
          const unit = key === "realValue" ? unitLeft : unitRight;
          const labelText = nameMap[key] ?? key;
          return (
            <p
              key={`${key}-${idx}`}
              className="text-sm font-medium"
              style={{ color: entry.color }}
            >
              {labelText}: {formatValue(entry.value, unit)}
            </p>
          );
        })}
    </div>
  );
}
